<template>
  <div>
    <!-- Header -->
    <div class="header pb-8" style="background-image: url(img/theme/hero-bg.jpg);">
    <b-nav align="right" class="mb-3" style="background-color: #ffffff7a">
      <b-nav-item to="/" class="text-primary mr-3"><i class="far fa-home"></i> Inicio</b-nav-item>
    </b-nav>
      <!-- <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">Use these awesome forms to login or create new account in your project for
                free.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>-->
      <b-container>
        <b-row class="justify-content-center">
          <b-col class="text-center">
            <b-img fluid src="img/brand/nuevo_logo.svg" width="200px"></b-img>
          </b-col>
        </b-row>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-info" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--6 pb-5" fluid>
      <b-row class="justify-content-center">
        <b-col lg="8" md="10">
          <b-card no-body class="border-0 mb-0">
            <b-card-body class="px-lg-3 py-lg-3">
              <b-alert show variant="light" class="text-primary">
                Indica el número de ticket, o tu folio UUID de la factura generada previamente.
              </b-alert>
              <b-form-group
                  label="Folio UUID"
                >
                <b-form-input
                  type="text"
                  size="sm"
                  class="form-control-solid"
                  placeholder="Folio UUID"
                  v-model="uuid"
                >
                </b-form-input>
              </b-form-group>
              <hr class="mt-0 mb-2">
              <b-row>
                <b-form-group
                  label="Sucursal"
                  class="col-6"
                >
                  <b-form-select v-model="sucursal_id" class="text-uppercase" size="sm">
                    <b-form-select-option v-for="(sucursal, ks) in sucursales" :key="ks" :value="sucursal.id">{{ sucursal.nombre }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Número de Ticket"
                  class="col-6"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    class="form-control-solid"
                    placeholder="Número de Ticket"
                    v-model="ticket"
                  >
                  </b-form-input>
                </b-form-group>
              </b-row>
              <b-button @click="findTicket()" :disabled="enableSearch" variant="primary" block>Buscar</b-button>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      working: false,
      error: [],
      sucursales: [],
      uuid: '',
      sucursal_id: '',
      ticket: ''
    };
  },
  computed: {
    enableSearch: function(){
      if(this.uuid != '' || (this.sucursal_id > 0 && this.ticket > 0)){
        return false
      } else {
        return true
      }
    }
  },
  beforeMount(){
    this.getSucursales()
  },
  methods: {
    getSucursales(){
      this.$api
      .get('/facturacion/sucursales')
      .then(response => {
        this.sucursales = response.data
      })
      .catch(e => console.error(e))
    },
    findTicket(){
      this.working = true

      .get('/facturacion/factura', {
        params: {
          uuid: this.uuid,
          sucursal_id: this.sucursal_id,
          ticket: this.ticket
        }
      })
      .then(response => {
        this.sucursales = response.data
      })
      .catch(e => console.error(e))
    }
  }
};
</script>
